import { useEffect } from 'react';

import { ArrowRight } from '@remarkable/ark-icons';
import { Typography } from '@remarkable/ark-web';

import { ComponentRendered } from 'src/ampli';
import { tracker } from 'src/analytics/tracker';
import { Button } from 'src/components';
import { ValueProps } from 'src/components/Offers/ValueProps';
import { PromotionCheckoutLink } from 'src/components/PromotionCheckoutLink';
import { StackedSheet } from 'src/components/StackedSheet';
import { SKU } from 'src/utils/skus';
import { URLS } from 'src/utils/urls/urls';
import { valueProps } from 'src/utils/valueProps';

import { Trans } from '@lingui/react/macro';
import { useFreeTrialDuration } from 'src/utils/freeTrialLength';
import { Highlight } from '../Highlight';
import { Price } from '../Price';

export const ConnectOffer = ({
  componentLocation,
  freeTrialLengthDays,
}: {
  componentLocation: string;
  freeTrialLengthDays: number;
}) => {
  const trialDuration = useFreeTrialDuration(freeTrialLengthDays);
  useEffect(() => {
    tracker.trackEvent(
      new ComponentRendered({
        component_name: 'ConnectOffer',
        component_type: 'hero',
      })
    );
  }, []);
  return (
    <StackedSheet dataCy="connect-offer-hero">
      <div data-cy="connect-offer" className="flex gap-24 ll:gap-0">
        <div className="flex flex-col gap-24 text-left lm:gap-32">
          <div className="flex flex-col">
            <Typography variant="interface-sm" leadingNone uppercase>
              <Trans>Connect subscription</Trans>
            </Typography>
            <Typography
              variant="responsive-heading-lg"
              className="mt-8 text-pretty lm:mt-24"
            >
              <Trans>
                Start your{' '}
                <Highlight scale={320}>{trialDuration} free</Highlight> trial
              </Trans>
            </Typography>
          </div>

          <div data-cy="connect-offer-perks" className="w-full">
            <ValueProps
              className="justify-start"
              valueProps={valueProps.connect}
            />
          </div>

          <div className="flex flex-wrap items-center gap-24">
            <Button
              as="a"
              variant="primary"
              to={URLS.STORE_CONNECT_OFFER_CHECKOUT}
              className="grow lm:grow-0"
              data-cy="connect-offer-hero-activate-button"
              analytics={{
                action: 'activate connect offer',
                location: componentLocation,
              }}
            >
              <span data-cy="connect-offer-activate-button">
                <Trans>Start free trial</Trans>
              </span>
              <ArrowRight />
            </Button>
            <PromotionCheckoutLink componentLocation={componentLocation} />
          </div>

          <Typography variant="body-sm" className="text-pretty">
            <Trans>
              The offer is valid for 30 days after pairing your device. Connect
              costs <Price sku={SKU.connectMonthly} />
              /mo. when your free trial ends. <b>Cancel anytime</b>.
            </Trans>
          </Typography>
        </div>
      </div>
    </StackedSheet>
  );
};
